import { useQuery } from '@tanstack/react-query'
import { getWorkBreaks } from 'api/work'
import { workKeys } from './keys'
import { QueryOptions } from 'queries/types'
import { useCompanyInfo } from '../company'

export function useWorkBreaks(
  workId: number,
  options: QueryOptions<typeof getWorkBreaks> = {}
) {
  const { data: company } = useCompanyInfo()
  const companyId = company?.id

  return useQuery({
    ...options,
    queryKey: workKeys.breaks(workId),
    queryFn: () => {
      if (companyId === undefined) {
        throw new Error('Company is required')
      }
      return getWorkBreaks(companyId, workId)
    },
    enabled: companyId !== undefined && (options.enabled ?? true),
  })
}
